module.exports = __webpack_public_path__ + "img/lincoln_logo.f7595a1b.jpg";